export const localStorageConstants = {
    IsAuthenticated: 'IS_AUTHENTICATED',
    AccessToken: 'ACCESS_TOKEN',
    RefreshToken: 'REFRESH_TOKEN',
    Account: 'ACCOUNT',
    User: 'USER'
};
